import { defineStore, storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useCompanyStore } from '@/stores/company';
import { useUserStore } from '@/stores/user';

const UNLEGIBLE_PLANS = [
  'register',
  'register_limited',
  'register_legacy',
  'register_limited_legacy',
  'lite',
];

export const useGoogleReserveStore = defineStore('googleReserve', () => {
  const { company, isTrial, activeSubscription } = storeToRefs(
    useCompanyStore(),
  );
  const { getApp } = useCompanyStore();
  const { hasFeatureFlag } = useUserStore();

  const showIntegration = computed(() => {
    return hasFeatureFlag('module-google-reserve');
  });

  const isEnabled = ref(false);
  const loading = ref(true);
  getApp('google_reserve')
    .then((app) => {
      isEnabled.value = !!app && app.state === 'active';
    })
    .finally(() => {
      loading.value = false;
    });

  const hasUnelegiblePlan = computed(() => {
    return (
      isTrial.value ||
      (activeSubscription.value?.plan &&
        UNLEGIBLE_PLANS.includes(activeSubscription.value.plan))
    );
  });

  const doesNotAllowNewCustomers = computed(() => {
    return !company.value.settings.bookings.allowNewCustomers;
  });

  const requireConfirmation = computed(() => {
    return company.value.settings.bookings.appointmentRequiresConfirmation;
  });

  return {
    loading,
    showIntegration,
    isEnabled,
    doesNotAllowNewCustomers,
    requireConfirmation,
    hasUnelegiblePlan,
  };
});
